import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '../button/Button';
// import "./areaCard.scss";

const AreaCard = props => {
    const area = props.area;
    // const alphabet = props.alphabet;
    const [imageLink, setImageLink] = useState('');
    useEffect(() => {
        const getImageLink = async area => {
            const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/filter.php?a=${area}`);
            setImageLink(response.data.meals[0].strMealThumb);
        }
        if(area.length > 1)
        getImageLink(area);
    }, [area]);
    return (
        <Link to={area.length===1 ? `/alphabets/${area}` : `/areas/${area}`}>
            <div className="category-card" style={{ backgroundImage: `url(${props.image || imageLink})` }}>
                <Button>View</Button>
            </div>
            <h3>{area}</h3>
        </Link>
    )
}

// AreaCard.propTypes = {
//     area: PropTypes.string.isRequired
// }

export default AreaCard